/**
 * Renders a circle dot for diving list items inside a flexbox container
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Yucho Ho
 */
import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import styles from './DotDivider.module.scss'

const DotDivider = ({ className }) => {
  return (
    <div className={cx(styles['dot-divider'], className)} />
  )
}

DotDivider.propTypes = {
  className: PropTypes.string
}

export default DotDivider
